<div
  class="dropzone"
  [class.dragging]="isDragging"
  [class.disabled]="disabled"
  (dragover)="onDragOver($event)"
  (dragleave)="onDragLeave($event)"
  (drop)="onDrop($event)"
  (click)="!disabled && fileInput.click()"
>
  <mat-icon>cloud_upload</mat-icon>
  <span class="dropzone-label">{{ label }}</span>
  <input
    #fileInput
    type="file"
    [accept]="accept === '*' ? null : accept"
    [multiple]="multiple"
    [disabled]="disabled"
    (change)="onFileInputChange($event)"
    hidden
  />
</div>

<p *ngIf="errorMessage" class="error-message">{{ errorMessage }}</p>
